import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { usersActionsSaga } from '../../../../infrastructure/services/users';
import { usersActions } from '../../../../application/actions/users';
import AvatarList from '../../molecula/AvatarList/AvatarList';
import CreateForms from '../../organismos/forms';
import Modal from '../../molecula/modal/Modal';
import 'moment/locale/es';
import './index.css'
import Fab from '@mui/material/Fab';
import { Box, Grid, Button, Typography, Tab, ButtonGroup } from '@mui/material';
import GradientCircularLoader from '../../molecula/circularLoader/circularLoader';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import { TabContext, TabList, TabPanel } from '@mui/lab';



const fabStyle = {
  position: 'absolute',
  bottom: 16,
  right: 16,
};

const UsersTemplate = () => {
  const dispatch = useDispatch();
  /*SHOW ALL DATA*/
  const { data: getAll, connection: connectionGetAll } = useSelector((store) => store.tk.users.getAll);
  const { data: getAllClient } = useSelector((store) => store.tk.client.getAll);

  /*SHOW BY ID AND UPDATE DATA*/
  const { connection: connectionById, data: usersById } = useSelector((store) => store.tk.users.getById);
  const { connection: connectionUpdate, result: resultUpdate } = useSelector((store) => store.tk.users.update);
  const [openUpdate, setOpenUpdate] = useState(false);
  const [openUpdateHome, setOpenUpdateHome] = useState(false);
  const [habilityUpdate, setHabilityUpdate] = useState(false);
  const [updateuser, setUpdateuser] = useState({});
  const [showUser, showUpdateuser] = useState([]);
  /*CREATE DATA*/
  const { data: role } = useSelector((store) => store.tk.role);
  const { connection: connectionCreate, result: resultCreate } = useSelector((store) => store.tk.users.create);
  const [openCreate, setOpencreate] = useState(false);
  const [habilityCreate, setHabilityCreate] = useState(false);
  const [createUser, setCreateUser] = useState({});
  const formulario = [{
    name: 'Usuario',
    groups: [
      {
        title: 'Datos del usuario',
        size: { xs: 12, sm: 12, md: 12 },
        display: true,
        fields: [
          {
            id: 'name',
            label: 'Nombre',
            kind: 'text',
            required: true,
            size: { xs: 12, sm: 6, md: 6 }
          },
          {
            id: 'lastName',
            label: 'Apellido',
            kind: 'text',
            required: true,
            size: { xs: 12, sm: 6, md: 6 }
          },
          {
            id: 'date',
            label: 'Fecha de nacimiento',
            kind: 'date',
            required: true,
            size: { xs: 12, sm: 6, md: 6 }
          },
          {
            id: 'numberId',
            label: 'Rut',
            kind: 'numberId',
            required: true,
            validations: ['CL'],
            size: { xs: 12, sm: 6, md: 6 }
          },
          {
            id: 'email',
            label: 'Email',
            kind: 'email',
            required: true,
            size: { xs: 12, sm: 12, md: 12 }
          },
          {
            id: 'roleIdUser',
            label: 'Rol',
            kind: 'list',
            required: true,
            options: role.map(item => ({ name: item.role, id: item.id })),
            size: { xs: 12, sm: 12, md: 12 }
          },
          {
            id: 'roleIdClientId',
            label: 'Cliente',
            kind: 'list',
            required: true,
            options: getAllClient.map(item => ({ name: item.nameComapny, id: item.id })),
            size: { xs: 12, sm: 12, md: 12 },
            display: true,
            showCondition: { field: 'roleIdUser', value: 10 }
          }
        ],
      },
      /* {
        title: 'Datos de sesion',
        size: { xs: 12, sm: 12, md: 12 },
        display: true,
        fields: [
          {
            id: 'userName',
            label: 'Nombre de usuario',
            kind: 'text',
            required: true,
            size: { xs: 12, sm: 6, md: 6 }
          },
          {
            id: 'password',
            label: 'Clave',
            kind: 'text',
            required: true,
            size: { xs: 12, sm: 6, md: 6 }
          },

        ],
      }, */
    ],
  }];

  /*SHOW ALL */
  const getAllItems = () => {
    dispatch(usersActionsSaga.getAllUsers());

  }

  useEffect(() => {
    getAllItems();
  }, []);

  const mapAvatarList = (data) => {
    const map = []
    data.map(x => map.push({
      id: x.id,
      title: `${x.name} ${x.lastName}`,
      subTitle: x.numberId,
      details: x.email
    }));
    return map;

  }

  /*SHOW BY ID AND UPDATE */


  const handleFindClienById = (id) => {
    setOpenUpdateHome(false)
    dispatch(usersActionsSaga.getByIdUsers({ id }));
  }

  const handlerShowAndupdate = () => {
    const status = openUpdate
    setOpenUpdate(!status)
    if (status) {
      //dispatch(usersActions.getById([]))
      setUpdateuser([])
    }
  }

  const getFieldsUpdate = (get) => {
    setUpdateuser(get)
  };
  const getEnabledFormUpdate = (flag) => {
    setHabilityUpdate(flag)
  };

  const showUserForm = <CreateForms
    fields={showUser}
    getFields={getFieldsUpdate}
    getEnabledForm={getEnabledFormUpdate}
    loader={connectionUpdate || connectionById}
  />

  const handleUpdate = () => {
    const createData = {}
    updateuser.map((F) => F.groups.map(G => G.fields.map(F => {createData[F.id] = F.value})))
    createData['id'] = usersById.id;
    dispatch(usersActionsSaga.updateUsers(createData));
  }

  const buttonUpdate = <ButtonGroup fullWidth ><Button sx={{ml:2, mr:2}} disabled={!habilityUpdate || connectionUpdate} onClick={handleUpdate}>Actualizar</Button></ButtonGroup>

  useEffect(() => {
    if (usersById.id && !connectionById) {
      const setform = formulario;
      setform.map((F) => F.groups.map(G => G.fields.map(F => {
        F.value = usersById[F.id]
        if(F.id==='email'){
          F.editable =true
        }

      })))
      showUpdateuser(setform)
      handlerShowAndupdate()
      setOpenUpdateHome(true)
    }

  }, [usersById, connectionById]);


  const reloadStates = () => {
    dispatch(usersActions.createReset())
    dispatch(usersActions.updateReset())
    getAllItems()
  }

  useEffect(() => {
    (resultUpdate || resultCreate) && reloadStates()
    setOpencreate(false)
    setOpenUpdate(false)
  }, [resultUpdate, resultCreate]);

  /*CREATE*/



  const handleShowModalCreate = (e) => {
    setOpencreate(!openCreate)
  }

  const getFieldsCreate = (get) => {
    setCreateUser(get)
  };

  const getEnabledFormCreate = (flag) => {
    setHabilityCreate(flag)
  };

  const creation = <CreateForms
    fields={formulario}
    getFields={getFieldsCreate}
    getEnabledForm={getEnabledFormCreate}
    loader={connectionCreate}
  />

  const handleCreate = () => {
    const createData = {}
    createUser.map((F) => F.groups.map(G => G.fields.map(F => createData[F.id] = F.value)))
    dispatch(usersActionsSaga.createUsers(createData));
  }
  const buttonCreate = <Button disabled={!habilityCreate || connectionCreate} onClick={handleCreate}>Crear Cliente</Button>

    const edit = () => {
      return <>
        <Grid sx={{ backgroundColor: '#6a6a6a', height: 'auto', p: 1, marginLeft: -2, paddingLeft: 4, paddingTop: 2 }}>
          <Typography sx={{ color: '#dcdcdc', fontSize: 25, }}>Usuario: {openUpdateHome && `${usersById.name} ${usersById.lastName}`}</Typography>
        </Grid>
        <Grid container >
          <Box sx={{ width: '100%', typography: 'body1' }} >
            <TabContext value={1}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList aria-label="lab API tabs example">
                  <Tab label="Datos del usuario" value={1} />
                </TabList>
              </Box>
              <TabPanel value={1}>
                <Grid container >
                  <Grid xs={12} sm={6} md={6}>
                    {showUserForm}
                    {buttonUpdate}
                  </Grid>
                </Grid>
              </TabPanel>
            </TabContext>
          </Box>
        </Grid>
      </>
    }

  return (
    <>
      {connectionById && <Box sx={{ backgroundColor: '#ffffff99', position: 'absolute', left: 0, right: 0, top: 0, bottom: 0, zIndex: 100, textAlign: 'center', paddingTop: '20%' }}><GradientCircularLoader /></Box>}
      <Fab onClick={(e) => handleShowModalCreate(e)} sx={fabStyle} color="primary" aria-label="add">
        <PersonAddIcon />
      </Fab>
      <Box className='dasboard' sx={{p:0}}>
        <Grid container spacing={2} sx={{ mt: 0 }}>
          <Grid sx={{ backgroundColor: '#FFF', overflowY: 'auto'}} item xs={12} sm={6} md={4}>
            {connectionGetAll && <Box sx={{ backgroundColor: '#ffffff99', textAlign: 'center', paddingTop: '50%' }}><GradientCircularLoader /></Box>}
            {!connectionGetAll && <AvatarList items={mapAvatarList(getAll)} action={handleFindClienById} selected={usersById.id} />}
          </Grid>
          <Grid item sx={{ overflowY: 'auto', p: 0, backgroundColor:'#e4e4e4ed' }} xs={12} sm={6} md={8}>
            {openUpdateHome && edit()}
          </Grid>
          {/* <Grid item sx={{ display: { xs: 'none', sm: 'block' }, overflowY: 'auto' }} xs={12} sm={6} md={8}>
            <Grid container >
              <Grid xs={12} sm={6} md={6}>
                <Box>
                  {edit}
                </Box>
                
              </Grid>
            </Grid>


          </Grid> */}
        </Grid>
      </Box>
      <Modal
        open={openCreate}
        handleClose={handleShowModalCreate}
        dataShow={creation}
        title={"Crear Cliente"}
        actions={buttonCreate}
      />

      <Modal
        open={openUpdate}
        handleClose={handlerShowAndupdate}
        dataShow={showUserForm}
        title={"Actualizar Cliente"}
        actions={buttonUpdate}
        sx={{ display: { xs: 'block', sm: 'none', md: 'none' } }}
      />

    </>
  );
};

export default UsersTemplate;